export enum EPageType {
  Listing = 'Listing',
  ListingJK = 'ListingJK',
  Card = 'Card',
  Other = 'Other',
  Home = 'Home',
  HomeSuburban = 'HomeSuburban',
  ListingFavorites = 'ListingFavorites',
}
